import React from 'react';
import { useTranslation } from 'react-i18next';

import { SimpleFormStep } from '@epi-pages/LoadBenefit/components/shared/SimpleFormStep';
import { FormStepMode } from '@epi-models/pages/Transfer';
import { StepField } from '@epi-pages/LoadBenefit/components/Topup/TopupForm/TopupForm.styles';
import { BenefitSelect } from '@epi-forms/controls/BenefitSelect/BenefitSelect';
import { IBenefits } from '@epi-models/pages/BenefitGroups';

interface BenefitSelectionProps {
  loadableBenefits: IBenefits[];
  stepNumber?: number;
  disabled?: boolean;
}

export const BenefitSelection = ({
  loadableBenefits,
  stepNumber = 1,
  disabled = false
}: BenefitSelectionProps) => {
  const { t } = useTranslation();

  return (
    <SimpleFormStep
      mode={FormStepMode.Outlined}
      stepNumber={stepNumber}
      stepTitle={t('containers.deposit_money.topup_tab.form.benefit.title')}
    >
      <StepField>
        <BenefitSelect options={loadableBenefits} disabled={disabled} />
      </StepField>
    </SimpleFormStep>
  );
};
